import React from 'react';

const AccountDeletion = () => {
  return (
    <div>
      <h2>Delete My Account</h2>
      <p>This feature is under construction.</p>
    </div>
  );
};

export default AccountDeletion;
